export default {
  tabs: {
    fc: 'Phân tích Nhanh',
    fr: 'Chỉ số ',
    zmf: 'Điểm ZMF',
  },

  tableParentCaption: {
    vr: 'Định Giá',
    pr: 'Sinh Lời',
    gr: 'Tăng Trưởng',
    lr: 'Thanh Toán',
    or: 'Hoạt Động',
    cr: 'Rủi Ro Tài Chính',
    d: 'Cổ Tức',
    car: 'An Toàn Vốn',
    aqr: 'Chất Lượng Tài Sản',
  },

  tableChildCaption: {
    //non-bank
    mc: 'Vốn Hóa (Tỷ VND)',
    os: 'CP lưu hành',
    eps: 'EPS (VND)',
    pe: 'P/E',
    pb: 'P/B',
    ps: 'P/S',
    pcf: 'P/Cash Flow',
    bvps: 'BVPS',
    ee: 'EV/EBITDA',

    rg: 'Tăng Trưởng Doanh Thu',
    eg: 'Tăng Trưởng EBIT',
    npg: 'Tăng Trưởng Lãi Thuần',
    roe: 'ROE',
    roa: 'ROA',
    roic: 'ROIC',
    gpm: 'Biên Lợi Nhuận Gộp',
    npm: 'Biên Lợi nhuận Thuần',

    cur: 'Tỷ lệ Thanh Toán Hiện Hành',
    car: 'Tỷ lệ Tiền Mặt',
    fl: 'Đòn Bẩy Tài Chính',
    ic: 'Tỷ lệ Thanh Toán Lãi Vay',

    dso: 'Thời gian TB thu tiền KH',
    dpo: 'Thời gian TB thanh toán cho NCC',
    dio: 'Thời gian TB xử lý HTK',
    at: 'Hệ số vòng quay tài Sản',
    dy: 'Tỷ lệ Cổ Tức',
    dpy: 'Hệ số Thanh Toán Cổ Tức',

    //bank
    dg: 'Tăng trưởng huy động vốn',
    lg: 'Tăng trưởng tín dụng',
    niig: 'Tăng trưởng Thu nhập Lãi Thuần',
    nim: 'NIM %',
    cir: 'Tỷ lệ Chi phí/ Thu Nhập (CIR)',
    nn: 'Thu nhập ngoài lãi/Thu nhập từ lãi',
    yoea: 'Tỷ suất Sinh lợi của Tài sản có sinh Lãi (YOEA)',
    acof: 'Chi phí Tài Chính Trung Bình (COF)',

    eli: 'Vốn CSH/Tổng Nợ',
    elo: 'Vốn CSH/Tổng Cho Vay',
    ea: 'Vốn CSH/Tài Sản',
    ldr: 'Chỉ số Dư Nợ trên Vốn Huy Động (LDR)',

    npl: 'Tỷ lệ Nợ Xấu',
    llrn: 'Dự phòng RR tín dụng/Nợ Xấu',
    llrl: 'Dự phòng RR tín dụng/Cho Vay',
    pol: 'Trích Lập Dự Phòng/Cho vay',

    // mc: 'Vốn hóa thị trường (Marcap)',
    // os: 'Số CP Lưu hành',
    // eps: 'EPS cơ bản',
    // epsg: 'Tốc độ tăng trưởng EPS',
    // peg: 'PEG',
    // pe: 'P/E cơ bản',
    // ped: 'P/E pha loãng',
    // pb: 'Hệ số Giá Cổ phiếu/Trị giá Sổ sách (P/B)',
    // ps: 'Hệ số Giá Cổ phiếu/Doanh số trên cổ phiếu (P/S)',
    // ptb: 'Hệ số Giá/Trị giá Sổ sách TSHH (P/Tangible Book)',
    // pcf: 'Hệ số giá/Dòng tiền (P/Cash Flow)',
    // ee: 'Giá trị Doanh nghiệp/EBITDA',
    // dg: 'Tăng trưởng huy động vốn',
    // cg: 'Tăng trưởng tín dụng',
    // ag: 'Tăng trưởng Tài sản',
    // eqg: 'Tăng trưởng vốn',
    // roe: 'ROE %',
    // roa: 'ROA %',
    // nim: 'Biên lãi suất ròng',
    // nn: 'Thu nhập ngoài lãi/Thu nhập từ lãi',
    // cir: 'Tỷ lệ chi phí / Thu nhập',
    // lta: 'Tỷ suất dư nợ/ Tổng tài sản',
    // ltd: 'Tỷ suất dư nợ/ Tiền gửi',
    // npl: 'Tỷ lệ nợ xấu',
    // ppl: 'Trích lập dự phòng/ Dư nợ cho vay',
    // rg: 'Tốc độ tăng trưởng doanh số thuần',
    // ebg: 'Tốc độ tăng trưởng EBIT',
    // cur: 'Tỷ suất thanh toán hiện thời',
    // car: 'Tỷ suất thanh toán tiền mặt',
    // ic: 'Hệ số thanh toán lãi vay',
    // dso: 'Thời gian trung bình thu tiền khách hàng',
    // dpo: 'Thời gian trung bình thanh toán cho nhà cung cấp',
    // dio: 'Thời gian trung bình xử lý HTK',
    // dy: 'Tỷ suất cổ tức',
    // dpy: 'Hệ số thanh toán cổ tức',
    // bvps: 'Giá trị sổ sách/CP (BV)',
    // roic: 'ROIC',
    // gpm: 'GPM',
    // fl: 'Tổng TS/ Tổng VCSH',
    // at: 'Hệ số vòng quay TS',
  },

  assetQualityChartTitle: {
    ta: 'Tổng Tài Sản',
    tl: 'Tổng Tín Dụng',
    tnpl: 'Tổng Nợ Xấu',
    npl: 'NPL',
  },

  profitabilityTitle: {
    bank: {
      roe: 'ROE %',
      roa: 'ROA %',
      nim: 'NIM %',
      cir: 'CIR %',
    },
    nonBank: {
      roe: 'ROE',
      roa: 'ROA',
      gpm: 'Biên Lãi Gộp',
      npm: 'BIên Lãi Thuần',
    },
  },

  lstTab: {
    faCheckup: 'Phân Tích Nhanh',
    financialRatio: 'Chỉ số Tài Chính',
    zmfScore: 'Đánh Giá ZMF',
  },

  faCheckupHeader: {
    checkupItem: '%{checkupItem}',
    comparingCheckupItemOne: '%{comparingCheckupItemOne}',
    comparingCheckupItemTwo: '%{comparingCheckupItemTwo}',
    item: 'Chỉ Tiêu',
  },

  faCheckupFooter: {
    excellent: 'Rất Tốt',
    good: 'Tốt',
    neutral: 'Trung Bình',
    beAlert: 'Cảnh Báo',
    watchOut: 'Nguy Hiểm',
    summary: `Để biết thêm thông tin về phương pháp đánh giá,
     <a target="_blank" rel="noreferrer noopener" href="%{url}">xem tại đây</a>
    `,
  },
  columnOneTable: {
    NON_BANKING: {
      RAPID_EQUITY_ISSUANCE: 'Phát hành vốn liên tục',
      REVENUE_GROWTH: 'Tăng Trưởng Doanh Thu',
      GROSS_PROFIT_MARGIN: 'Biên Lãi Gộp',
      PROFIT_GROWTH: 'Tăng Trưởng Lợi Nhuận',
      CFO_QUALITY: 'Chất Lượng Dòng Tiền',
      OPERATION_EFFICIENCY: 'Khả Năng Thanh Toán',
      DEBT_PRESSURE: 'Áp Lực Nợ Vay',
      CAPITAL_STRUCTURE: 'Cấu Trúc Vốn',
      ROE: 'ROE',
      FINANCIAL_PLANNING: 'Năng lực thực hiện kế hoạch',
    },
    BANKING: {
      DEPOSIT_GROWTH: 'Tăng Trưởng Huy Động',
      CREDIT_GROWTH: 'Tăng Trưởng Tín Dụng',
      INTEREST_PROFIT_GROWTH: 'Tăng Trưởng Thu Nhập Từ Lãi',
      NIM_RATIO: 'Hệ Số NIM',
      LDR_Ratio: 'Hệ Số LDR',
      NPL_Ratio: 'Hệ Số NPL',
      CAR_Ratio: 'Hệ Số CAR',
      Business_Plan: 'Kế Hoạch Tài Chính',
    },
  },

  titleChart: {
    dupont: 'DUPONT',
    profitability: 'KHẢ NĂNG SINH LỢI',
    percentage: 'Phần trăm',
    time: 'Lần',
    trillion: 'Tỷ VND',
  },

  zTooltip: {
    firstRow: 'Xác suất phá sản của công ty ',
    secondRow: 'sản xuất và thương mại đại chúng',
  },

  mTooltip: {
    firstRow: 'Khả năng thao túng quá trình',
    secondRow: 'ghi nhận lợi nhuận của công ty',
  },

  fTooltip: {
    firstRow: 'Tiềm lực tài chính của doanh nghiệp',
  },

  footerNoteZBarChart: {
    safe: 'An toàn',
    nomal: 'Có dấu hiệu cảnh báo',
    distress: 'Có dấu hiệu nguy hiểm',
  },

  footerNoteMBarChart: {
    notManipulator: 'Bình thường',
    manipulator: 'Có dấu hiệu thao túng',
  },

  footerNoteFBarChart: {
    good: 'Lành mạnh',
    normal: 'Bình Thường',
    weak: 'Dấu hiệu yếu kém',
  },

  listTitleTableFinancialRatio: {
    item: 'Chỉ tiêu',
    industry: 'Ngành',
  },
  zmfFooter: `Để thêm chi tiết về cách tính toán Z-Score, M-Score và F-Score
     <a target="_blank" rel="noreferrer noopener" href="%{url}">Xem tại đây</a>
    `,
  financialRatio: {
    compareTo: 'So sánh với',
    timeTab: {
      quarterly: 'Quý',
      yearly: 'Năm',
    },
    industry: 'Ngành',
    ratioTitle: 'Ratio',

    revenue: 'Doanh thu (Tỷ đồng)',
    revenueGrowth: 'Tăng trưởng doanh thu (YoY) (%)',
    netProfit: 'Lợi nhuận sau thuế của Cổ đông công ty mẹ (Tỷ đồng)',
    profitGrowth: 'Tăng trưởng lợi nhuận (YoY) (%)',
    EBITMargin: 'Biên EBIT (%)',
    netProfitMargin: 'Biên lợi nhuận ròng (%)',
    grossProfitMargin: 'Biên lợi nhuận gộp (%)',
    ROE: 'ROE (%)',
    ROIC: 'ROIC (%)',
    ROA: 'ROA (%)',

    currentRatio: 'Chỉ số thanh toán hiện thời',
    cashRatio: 'Chỉ số thanh toán tiền mặt',
    quickRatio: 'Chỉ số thanh toán nhanh ',
    interestCoverage: 'Khả năng chi trả lãi vay',
    financialLeverage: 'Đòn bẩy tài chính ',

    assetTurnover: 'Vòng quay tài sản ',
    fixedAssetTurnover: 'Vòng quay TSCĐ',
    daysSalesOutstanding: 'Số ngày thu tiền bình quân',
    daysInventoryOutstanding: 'Số ngày tồn kho bình quân',
    daysPayableOutstanding: 'Số ngày thanh toán bình quân',
    cashCycle: 'Chu kỳ tiền',

    debt: 'Nợ/VCSH',
    STAndLTBorrowing: '(Vay NH+DH)/VCSH',

    marketCapital: 'Vốn hóa (Tỷ đồng)',
    outstandingShare: 'Số CP lưu hành (Triệu CP)',
    PE: 'P/E',
    PB: 'P/B',
    PS: 'P/S',
    PCashFlow: 'P/Cash Flow',
    EPS: 'EPS (VND)',
    BVPS: 'BVPS (VND)',
    EV: 'EV/EBITDA',

    effectiveRatio: 'Nhóm hiệu quả hoạt động',
    liquidityRatio: 'Nhóm chỉ số thanh toán',
    efficiencyRatio: 'Nhóm hiệu suất hoạt động',
    capitalStructureRatio: 'Nhóm cơ cấu nguồn vốn',
    valuationRatio: 'Nhóm định giá',
    coporationInfomation: 'Nhóm thông tin doanh nghiệp',

    //Banking
    netInterestIncome: 'Thu nhập lãi thuần (Tỷ đồng)',
    netInterestIncomeGrowth: 'Tăng trưởng thu nhập lãi thuần (YoY) (%)',
    NIM: 'NIM (%)',
    depositGrowth: 'Tăng trưởng tiền gửi (%)',
    loansGrowth: 'Tăng trưởng tín dụng (%)',
    costToIncome: 'Chi phí/Thu nhập (%)',
    nonInterestIncomeInterestIncome: 'Thu nhập ngoài lãi/Thu nhập từ lãi (%)',
    YOEA: 'Tỷ suất sinh lợi của Tài sản có sinh lãi (YOEA) (%)',
    COF: 'Chi phí tài chính trung bình (COF) (%)',

    equityPerLiabilities: 'Vốn CSH/Tổng Nợ ',
    equityPerLoans: 'Vốn CSH/Tổng Cho vay ',
    equityPerAssets: 'Vốn CSH/Tài sản',
    LDR: 'LDR (%)',
    CAR: 'CAR (%)',

    CASARatio: 'Tỷ lệ CASA',
    NPL: 'Tỷ lệ Nợ xấu (%) ',
    NPLs: 'Dự phòng RR tín dụng/Nợ xấu (%)',
    LLRL: 'Dự phòng RR tín dụng/Cho vay (%)',
    POL: 'Trích lập dự phòng/Cho vay (%)',
    footerNote: 'Lưu ý: Tăng trưởng được tính trên dữ liệu cùng kỳ năm trước',
    footerNoteYearly: 'Lưu ý: Dữ liệu ngành đang được tính theo năm.',
    industryNote: 'Dữ liệu ngành theo chuẩn phân ngành cấp 3 ICB',

    effectiveRatio: 'Nhóm hiệu quả hoạt động',
    capitalRatio: 'Nhóm chỉ số an toàn',
    assetQualityRatio: 'Nhóm chỉ số chất lượng tài sản',
    valuationRatio: 'Nhóm chỉ số định giá',
    coporationInfomation: 'Nhóm thông tin doanh nghiệp',
  },
};
